import { render } from "./DynamicTable.vue?vue&type=template&id=72d21a05"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QList from 'quasar/src/components/item/QList.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QChip from 'quasar/src/components/chip/QChip.js';import Resize from 'quasar/src/directives/resize/Resize.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QCheckbox,QList,QPagination,QInfiniteScroll,QSpinnerDots,QChip});qInstall(script, 'directives', {Resize});
